import React, { useState, createContext, ReactNode } from "react";

interface ToggleContextType {
  isOpen: boolean;
  toggle: () => void;
  setIsOpen: (open: boolean) => void;
}

export const ToggleContext = createContext<ToggleContextType>({
  isOpen: false,
  toggle: () => {},
  setIsOpen: () => {},
});

interface ToggleProviderProps {
  children: ReactNode;
}

export const ToggleProvider: React.FC<ToggleProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <ToggleContext.Provider value={{ isOpen, toggle, setIsOpen }}>
      {children}
    </ToggleContext.Provider>
  );
};
